import { useEffect, useLayoutEffect, useRef, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { fetchUserById } from '../../features/user/userThunks'
import { useSelector } from 'react-redux'

const useCaseLayout = () => {
  const {
    data: zoneDetails,
    loading,
    error,
  } = useAppSelector((state) => state.zone)

  return {
    loading,
  }
}

export default useCaseLayout
